const list = {
  paymentMethod: 'PaymentMethod',
  courierService: 'CourierService',
  voucherUsageV2: 'VoucherUsageV2',
  administratorV2: 'AdministratorV2',
  voucherV2: 'VoucherV2',
  userV2: 'UserV2',
  dashboardRegistry: 'DashboardRegistry',
  dashboardProduct: 'DashboardProduct',
  dashboardBrand: 'DashboardBrand',
  dashboardMonthly: 'DashboardMonthly',
  product: 'Product',
  productApproval: 'ProductApproval',
  transferProduct: 'TransferProduct',
  user: 'User',
  role: 'Role',
  brand: 'Merchant',
  brandV2: 'MerchantV2',
  banner: 'Banner',
  bannerV2: 'BannerV2',
  voucher: 'Voucher',
  category: 'Category',
  categoryV2: 'CategoryV2',
  faq: 'Faq',
  faqCategory: 'FaqCategory',
  transaction: 'Transaction',
  transactionV2: 'TransactionV2',
  collection: 'Collection',
  permission: 'Permission',
  merchantProfile: 'MerchantProfile',
  notification: 'Notification',
  setting: 'Setting',
  review: 'Review',
  article: 'Article',
  articleCategory: 'ArticleCategory',
  affiliate: 'Affiliate',
  chat: 'Chat',
  sale: 'Sale',
  saleAllBrand: 'SaleAllBrand',
}

export default list
